import React, { useCallback, useState, useRef, useEffect } from 'react';
import ContentCopy from '@material-ui/icons/FileCopy';
import { IconButton, Tooltip } from '@material-ui/core';
import copy from 'clipboard-copy';

interface ICopyToClipboard {
  content: string | number;
  type?: 'icon' | 'content';
  className?: any;
  style?: any;
}

export const CopyToClipboard = (props: ICopyToClipboard) => {
  const content = props.content.toString();

  const [showTooltip, setShowTooltip] = useState<boolean>(false);
  const [tooltipText, setTooltipText] = useState<string>('Click to copy');

  const tId = useRef<NodeJS.Timeout>();

  const handleClick = useCallback(
    async e => {
      e.preventDefault();
      e.stopPropagation();

      await copy(content);

      setTooltipText('Copied!');
      setShowTooltip(true);
      tId.current = setTimeout(() => setShowTooltip(false), 3000);
    },
    [content],
  );

  const handleOver = useCallback(() => {
    setShowTooltip(true);
    setTooltipText('Click to copy');
  }, []);

  const handleOut = useCallback(() => {
    setShowTooltip(false);
  }, []);

  useEffect(() => {
    return () => {
      if (tId.current !== undefined) {
        clearTimeout(tId.current);
      }
    };
  }, []);

  return (
    <Tooltip title={tooltipText} open={showTooltip} arrow>
      {props.type === 'icon' ? (
        <IconButton onClick={handleClick} size="small" style={{ marginLeft: 2 }}>
          <ContentCopy style={{ fontSize: 16 }} color="disabled" />
        </IconButton>
      ) : (
        <span
          onClick={handleClick}
          style={{ cursor: 'pointer', ...props.style }}
          onMouseOver={handleOver}
          onMouseOut={handleOut}
          className={props.className}
        >
          {content}
        </span>
      )}
    </Tooltip>
  );
};
